import { z } from 'zod';

export const adCampaignSchema = z.object({
  id: z.string().uuid(),
  clientPlatformAccountId: z.string().uuid(),
  agencyId: z.string().uuid(),
  platform: z.string(),
  externalId: z.string(),
  name: z.string(),
  status: z.enum(['ACTIVE', 'PAUSED', 'DELETED', 'ARCHIVED']),
  effectiveStatus: z.string().nullable().optional(),
  objective: z.string().nullable().optional(),
  budgetType: z.enum(['DAILY', 'LIFETIME', 'NONE']).nullable().optional(),
  budgetAmount: z.number().nullable().optional(),
  startDate: z.string().nullable().optional(),
  endDate: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type AdCampaignSchema = z.infer<typeof adCampaignSchema>;

export const adAccountSnapshotSchema = z.object({
  id: z.string().uuid(),
  clientPlatformAccountId: z.string().uuid(),
  platform: z.string(),
  snapshotDate: z.string(),
  fetchedAt: z.coerce.date(),
  spend: z.number().nullable().optional(),
  impressions: z.number().nullable().optional(),
  reach: z.number().nullable().optional(),
  frequency: z.number().nullable().optional(),
  clicks: z.number().nullable().optional(),
  linkClicks: z.number().nullable().optional(),
  uniqueLinkClicks: z.number().nullable().optional(),
  cpm: z.number().nullable().optional(),
  cpc: z.number().nullable().optional(),
  ctr: z.number().nullable().optional(),
  cpp: z.number().nullable().optional(),
  purchases: z.number().nullable().optional(),
  purchasesValue: z.number().nullable().optional(),
  leads: z.number().nullable().optional(),
  roas: z.number().nullable().optional(),
  videoViews: z.number().nullable().optional(),
  videoViewRate: z.number().nullable().optional(),
  partial: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type AdAccountSnapshotSchema = z.infer<typeof adAccountSnapshotSchema>;
